var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn d-inline-block",on:{"click":function($event){return _vm.$emit('click', _vm.prev)}}},[_c('Icon',{staticClass:"icon",attrs:{"name":_vm.iconName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }